<template>
  <div class="content-item flex">
    <div class="content-item-label">
      <span v-if="JSON.parse(commonData[0].value)==='1'" class="red">*</span>是否传染病
    </div>
    <el-radio-group v-model="radio" class="flex align-items-center">
      <el-radio :label="1">是</el-radio>
      <el-radio :label="0">否</el-radio>
    </el-radio-group>
  </div>
</template>

<script>
import publicTool from '@/utils/public';
export default {
  name: "InfectiousMark",
  props: ['infectiousMark', 'commonData', 'actionType', ],
  data() {
    return {
      name: publicTool.actionTypeCheck(this.actionType) + '名称',
    };
  },
  computed: {
    radio: {
      get() {
        console.log(this.infectiousMark);
        return this.infectiousMark
      },
      set(val) {
        this.$emit('update:infectiousMark',val)
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
